module.exports = __webpack_public_path__ + "static/K-Love-e2fdbaa2f4fc8d2dea7c3a5ace5b4393.png";